var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('excise-transactions',{attrs:{"listObject":"spirit","objectId":_vm.spiritId,"back":[{text:'Spirits',to:{name:'Spirits'}}],"contents":false,"vessel":"","exciseTypes":_vm.excise.spiritsExciseTypes(true)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }